// i18n area 'apps' — locale sq-AL (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.sq-AL.meta.json.
import type { enUS } from './apps'

export const sqAL: typeof enUS = {

  // Apps wave 1 (Annex R): container podman gestiti — supervisionati dal
  // worker su un nodo dichiarato; immagine = lockfile branch@digest (Annex Q)
  // con policy pinned/tracking; attacco L3 untagged con IP statico.
  apps: {
    title: 'App',
    create: 'Krijo app',
    createTitle: 'Krijo app',
    editTitle: 'Modifiko app-in',
    name: 'Emri',
    nameHint: 'DNS-1123, unik në scope — i pandryshueshëm pas krijimit.',
    node: 'Nyja',
    nodeHint: 'Nyja anëtare që e shërben — placement eksplicit (scheduler-i vjen më vonë).',
    image: 'Imazhi',
    editImageHint: 'Një referencë e re ri-zgjidhet përmes evidencës — gjesti i pin-it/rollback-ut.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digest-i lëviz vetëm me komandë.',
    policyTrackingHint: 'Rolling automatik kur një rifreskim e lëviz branch-in.',
    archMovePolicy: 'Zhvendosje cross-arch',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Çfarë ndodh nëse app-i zhvendoset në një node të një arkitekture tjetër: refuse e refuzon zhvendosjen, reresolve e rizgjidh lockfile-in nga branch-i në arch-in e ri — përmbajtja ndryshon, dhe përgjigja e emërton ndryshimin e digest-it.',
    network: 'Rrjeti',
    networkHint: 'Lidhje L3 untagged: një rrjet logjik i fabric-ut (i këshilluar — gateway/DNS nga burimi i tij i vetëm), një overlay, ose një bridge host i zhveshur (i pakëshillueshëm).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'bridge host:',
    ipAssignment: 'Caktimi i IP-së',
    ipStatic: 'Statik',
    ipAuto: 'Automatik (IPAM)',
    ipAssignmentHint_static: 'Adresën e jep ti, tani.',
    ipAssignmentHint_auto: 'IPAM-i zgjedh një adresë të lirë nga range-t e rrjetit të rezervuar për TVirt.',
    bridgeDiscouraged: 'Bridge host i zhveshur — I PAKËSHILLUESHËM: TVirt nuk di asgjë për adresimin e tij, prandaj gateway-i dhe DNS-i duhen dhënë me dorë. Rruga e këshilluar është një rrjet logjik i fabric-ut.',
    ip: 'IP',
    ipHint: 'IPv4 statik brenda nënrrjetit të lidhjes.',
    ipCidrHint: 'Në formë CIDR mbi një bridge të zhveshur (p.sh. 192.168.1.10/24) — s’ka nga të derivohet prefiksi.',
    gateway: 'Gateway',
    gatewayManualHint: 'Manual — një bridge i zhveshur nuk derivon asgjë.',
    dnsServers: 'Serverët DNS',
    dnsManualHint: 'Manualë, të ndarë me presje — të paktën një.',
    rootKind: 'Root',
    rootEphemeral: 'efemere',
    rootPersistent: 'persistente',
    rootEphemeralHint: 'E rikrijuar nga imazhi në çdo rikrijim; jeton në storage-in efemer të klasterit.',
    rootEphemeralHintNamed: 'E rikrijuar nga imazhi në çdo rikrijim; jeton në storage-in efemer të klasterit ({name}).',
    rootPersistentHint: 'U mbijeton rinisjeve; jeton në storage-in që zgjedh ti.',
    rootStorage: 'Storage root',
    editRootStorageHint: 'Root-i ri-renderizohet në pool-in e ri — të dhënat ekzistuese NUK zhvendosen vetë.',
    volumes: 'Volumet',
    volumeAdd: 'Shto volum',
    volumeName: 'Emri',
    volumeMountPath: 'Shtegu i mount-it',
    volumeKind: 'Tipi',
    volumeStorage: 'Storage',
    devices: 'Pajisje',
    deviceClassHint: 'Kërkohet një KLASË (një etiketë gpu-device ose usb-device), kurrë një pajisje e caktuar: nyja e deklaruar duhet të ketë një të shënuar për Apps. Disa Apps mund të përdorin të njëjtën pajisje — një kontejner e ndan, nuk ia heq host-it.',
    deviceSlot: 'Slot',
    deviceTag: 'Etiketë',
    deviceValue: 'Klasë',
    deviceUnresolved: 'tani nuk zgjidhet asgjë',
    noDeviceTags: 'Ende asnjë etiketë e llojit gpu-device ose usb-device: krijo një dhe cakto te pajisjet e shënuara për Apps.',
    env: 'Mjedisi',
    envHint: 'Një ÇELËS=vlerë për rresht.',
    secretEnvTitle: 'Variabla sekrete',
    secretEnvNotice: 'Një vlerë sekrete nuk kthehet më kurrë nga API: askush nuk e lexon sërish, as ai që e shkroi. Në checkpoint udhëton e vulosur me masterpass-in, prandaj një rikthim pa masterpass do të kërkojë ta shkruani sërish.',
    secretEnvPromote: 'Bëje sekrete një nga variablat e shkruara më sipër:',
    secretEnvAdd: 'Shto variabël sekrete',
    secretEnvName: 'Emri',
    secretEnvValue: 'Vlera',
    secretEnvKept: 'e ruajtur — lëre bosh që të mos ndryshojë',
    secretEnvWithdrawWarning: 'Për të mos e trajtuar më si sekrete një variabël që tashmë është, shkruaji një vlerë të re: heqja e shenjës më vete do të ishte një mënyrë për të LEXUAR atë që nuk del kurrë nga store-i. Ndërsa heqja e variablës e fshin atë.',
    secretEnvChip: 'sekret',
    startNow: 'Nise menjëherë (përndryshe app-i lind i ndalur)',
    deletePersistentIntro: 'Ky app ka të dhëna persistente — zgjidh çfarë të bëhet me to:',
    deleteKeepData: 'Mbaji të dhënat (direktoritë mbeten në storage-et e tyre, jetime)',
    deletePurgeData: 'Fshi edhe të dhënat',
    phase: 'Faza',
    phase_running: 'Në ekzekutim',
    phase_stopped: 'I ndalur',
    phase_error: 'Gabim',
    phase_unknown: 'E panjohur',
    desiredState: 'I dëshiruar',
    wantedRunning: 'në ekzekutim',
    wantedStopped: 'i ndalur',
    start: 'Nis',
    stop: 'Ndalo',
    restart: 'Rinis',
    refreshImage: 'Rifresko imazhin (adopton @current-in e ri)',
    logs: 'Log',
    logsTitle: 'Log',
    logsEmpty: 'Asnjë output i kapur.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'App-i nuk është në ekzekutim — një shell ka nevojë për një kontejner të gjallë. Log-et e tij lexohen në çdo gjendje.',
    shellConnect: 'Lidhu',
    shellDisconnect: 'Shkëputu',
    shellExited: 'Sesioni përfundoi me kodin e daljes {code}.',
    shellEndedWithoutStatus: 'Sesioni përfundoi pa një status daljeje: {reason}',
    shellRevoked: 'Ticket-i i sesionit nuk është më i vlefshëm — skadoi, ose hyrja që e hapi u revokua.',
    shellHint: 'Kliko në kutinë e zezë dhe shkruaj: tastet arrijnë te kontejneri. Ctrl+C dhe shigjetat funksionojnë; exit mbyll shell-in.',
    shellStatus: {
      connecting: 'Duke u lidhur…',
      connected: 'E lidhur',
      ended: 'Përfunduar'
    },
    deleteRunningError: '{name} kërkohet në ekzekutim — ndaloje më parë.',

    // Dialog standard (round #156): i tab del dettaglio e i campi contract
    // mancanti — ogni campo dell'App visibile, lucchetti col perché.
    tabs: {
      general: 'Të përgjithshme',
      image: 'Imazhi',
      network: 'Rrjeti',
      storage: 'Storage',
      devices: 'Pajisje',
      observed: 'Të vëzhguara'
    },
    attachment: 'Lidhja',
    runningDigest: 'Digest-i në ekzekutim',
    lastError: 'Gabimi i fundit',
    reportObservedAt: 'Raporti i fundit i worker-it',
    desiredStateLock: 'E qeverisin veprimet Nis/Ndalo — kurrë një modifikim i drejtpërdrejtë.',
    ipEditDisabledHint: 'I modifikueshëm vetëm me caktim statik.',
    derivedFromNetworkHint: 'I derivuar nga burimi i vetëm i rrjetit — manual vetëm mbi bridge të zhveshur me IP statik.',
    ephemeralUnset: 'i pakonfiguruar',
    ephemeralMissing: 'Storage-i efemer i App-eve nuk është konfiguruar — krijimi i një app-i me pjesë efemere (root ose volume) refuzohet derisa ta caktosh.',
    ephemeralCurrent: 'Storage-i efemer i App-eve: {name}',
    ephemeralMissingCreate: 'Ky app ka pjesë efemere, por storage-i efemer i App-eve nuk është caktuar — krijimi do të refuzohet. Caktoje më parë nga banner-i i faqes App.',
    setEphemeral: 'Cakto storage-in efemer',
    changeEphemeral: 'Ndrysho storage-in efemer',
    setEphemeralTitle: 'Cakto storage-in efemer të App-eve',
    changeEphemeralTitle: 'Ndrysho storage-in efemer të App-eve',
    ephemeralStorageHint: 'DEFAULT i klasterit: pool-i dir-like ku jetojnë root-et dhe volumet efemere të çdo app-i, përveç kur app-i deklaron një override. Një ndërrim nuk ndodh live dhe nuk rindez asgjë: vlen nga nisja e ardhshme e secilit app — të dhënat efemere nuk zhvendosen.',
    ephemeralPool: 'Pool storage-i',
    ephemeralOverride: 'Storage efemer (override për-app)',
    ephemeralOverrideInherit: 'Trashëgon default-in e klasterit',
    ephemeralOverrideInheritNamed: 'Trashëgon default-in e klasterit ({name})',
    ephemeralOverrideHint: 'Pool për-app për root-et dhe volumet efemere — lëre bosh për të trashëguar default-in e klasterit. Ndërrimi nuk ndodh live dhe nuk rindez asgjë: vlen nga nisja e ardhshme (të dhënat efemere rilindin bosh në pool-in e ri) dhe kërkon lejen app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Të gjitha degët',
    imageBranchHint: 'Ngushton imazhet te ato që emërton kjo degë; pa degë shihen të gjitha imazhet e depos.',
    imageDigestHint: 'Përmbajtja: zgjidhet nga tabela e digest-eve, që mban prejardhjen dhe arkitekturën e saj. E njëjta degë ofron një për çdo arkitekturë, dhe nuk janë të këmbyeshme.',
    imageLockfile: 'Referencë e zgjidhur',
    imageNoImages: 'Asnjë imazh në cache për këtë depo — shkarko një nga Imazhe OCI.',
    imageHeadNotCached: 'jo në cache — shkarkohet në nisje',
    imageNoRegistries: 'Asnjë depo e regjistruar: regjistro një që të mund të zgjedhësh një imazh.',
    imageChosenHint: 'Imazhi zgjidhet nga kaskada në dialogun e ndryshimit: referenca nuk shkruhet kurrë me dorë.',
    registerRepositoryHint: 'Regjistrimi nuk shkarkon asgjë: e bën një depo të vëzhgueshme, që imazhi të zgjidhet pa dalë nga ky dialog.',
    registerRepositoryBranchHint: 'Opsionale: dega e parë për t’u vëzhguar (p.sh. latest).',
    registerRepositoryElsewhere: 'Depoja që kërkon nuk është e regjistruar: regjistrimi bëhet te seksioni Imazhe OCI, nga dikush që ka lejen.'
  },

  // Template CT (round K2 #63): gli oggetti CT MATERIALIZZATI — l'import da
  // catalogo è l'unico ingresso; i file si caricano dentro i cataloghi.
  cts: {
    createAction: 'Krijo CT',
    createTitle: 'Krijo një kontejner nga një shabllon',
    createError: 'Kontejneri nuk u krijua',
    template: 'Shablloni CT',
    noTemplates: 'Asnjë shabllon CT — importo një nga Shabllonet CT',
    resources: 'Burimet',
    node: 'Nyja',
    phase: {
      defined: 'Asnjëherë i ndezur',
      materializing: 'Në materializim',
      ready: 'Gati',
      starting: 'Duke u nisur',
      running: 'Në ekzekutim',
      stopping: 'Duke u ndalur',
      stopped: 'I ndalur',
      deleting: 'Duke u fshirë',
      error: 'Në gabim'
    },
    actions: {
      start: 'Nis',
      stop: 'Ndalo',
      restart: 'Rinis',
      markTemplate: 'Promovo në shabllon CT',
      error: 'Veprimi u refuzua'
    },
    markTemplate: {
      confirmTitle: "Të promovohet '{name}' në shabllon CT?",
      confirmBody: 'Kontejneri e lë këtë listë dhe kalon te Shabllonet CT, menjëherë gati të gjenerojë CT të rinj. Metadatat mbeten të modifikueshme, dhe mund ta kthesh në CT në çdo moment.',
      confirm: 'Promovo',
      moved: "'{name}' tani është një shabllon CT — e gjen te Shabllonet CT."
    },
    stopCause: {
      api: 'Ndalur nga TVirt',
      'ct-exit': 'Kontejneri doli vetë',
      'host-reboot': 'Vdiq me rinisjen e nyjes',
      'start-failed': 'Nisja dështoi — gabimi i task-ut thotë çfarë mungon dhe si rregullohet'
    },

    console: 'Konsola',
    consoleUnavailable: 'Kontejneri nuk është në ekzekutim — një konsolë ka nevojë për një kontejner të gjallë. Logu i tij, përkundrazi, lexohet në çdo gjendje.',
    consoleNoTemplate: 'Një shabllon nuk ekzekutohet kurrë, prandaj nuk ka konsolë: krijo prej tij një CT dhe hap atë të tijën.',
    consoleConnect: 'Lidhu',
    consoleDisconnect: 'Shkëputu',
    consoleReconnect: 'Rilidhu',
    consoleTakenBy: 'Këtë konsolë e mori një operator tjetër ({user}). Një konsolë për kontejner: rilidhja ta merr sërish.',
    consoleHint: 'Kliko katrorin e zi dhe shkruaj: tastet mbërrijnë te kontejneri. Ctrl+C dhe shigjetat funksionojnë.',
    consoleEndpointDown: 'Pika e hyrjes së konsolës nuk hapet në nyjen që shërben container-in: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Container-i nuk është në ekzekutim — një shell ka nevojë për një container të gjallë. Log-et e tij lexohen në çdo gjendje.',
    shellNoTemplate: 'Një template nuk ekzekutohet kurrë, prandaj nuk ka shell: krijo një CT prej tij dhe hap atë të tijin.',
    shellConnect: 'Lidhu',
    shellDisconnect: 'Shkëputu',
    shellExited: 'Sesioni përfundoi me kodin e daljes {code}.',
    shellEndedWithoutStatus: 'Sesioni përfundoi pa një status daljeje: {reason}',
    shellRevoked: 'Ticket-i i sesionit nuk është më i vlefshëm — skadoi, ose hyrja që e hapi u revokua.',
    shellHint: 'Kliko në kutinë e zezë dhe shkruaj: tastet arrijnë te kontejneri. Ctrl+C dhe shigjetat funksionojnë; exit mbyll shell-in.',
    shellStatus: {
      connecting: 'Duke u lidhur…',
      connected: 'E lidhur',
      ended: 'Përfunduar'
    },
    rootPassword: 'Fjalëkalimi i root',
    rootPasswordHint: 'Shkruhet një herë në rootfs-in e kopjuar (si hash, nuk shfaqet më). Image-t e distribucioneve nuk kanë fjalëkalim root: pa të, shell-i është hyrja e vetme.',
    sshKeys: 'Çelësat publikë SSH të root',
    sshKeysHint: 'Një çelës publik OpenSSH për rresht, në root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Duke u lidhur…',
      connected: 'E lidhur',
      reconnecting: 'Duke u rilidhur…'
    },
    logs: 'Log',
    logsTitle: 'Log',
    logsEmpty: 'Asnjë output i kapur.',
    logsSource: 'Cili log',
    logsSourceConsole: 'Konsola e initit të kontejnerit — pse shërbimi brenda nuk u nis',
    logsSourceSupervisor: 'Mbikëqyrësi liblxc — pse kontejneri nuk arriti kurrë as të nisej',
    logsNeverStarted: 'Nuk është nisur kurrë, prandaj ende nuk ka asgjë të regjistruar — nise, dhe logu do të jetë aty edhe nëse nisja dështon.',
    logsNoTemplate: 'Një shabllon nuk ekzekutohet kurrë, prandaj nuk ka regjistruar kurrë asgjë.',
    logsError: 'Logu nuk u kap',

    // Dialog standard (round #156): i tab del dettaglio condivisi dalle
    // liste CT e Template CT, più i lucchetti col perché.
    tabs: {
      general: 'Të përgjithshme',
      hardware: 'Hardware',
      network: 'Rrjeti',
      provenance: 'Prejardhja'
    },
    templateFlag: 'Shabllon CT',
    templateLock: 'Ndryshohet vetëm me veprimet Promovo / Ktheje në CT — kurrë me një modifikim të drejtpërdrejtë.',
    sourceLock: 'Prejardhja, e regjistruar në lindje — kurrë e rishkruar; një burim i vdekur e lë referencën të zhveshur.',
    storageLock: 'I fiksuar në krijim — zhvendosja e rootfs-it është një round i ardhshëm.',
    startedAt: 'Nisur',
    lastStop: 'Ndalimi i fundit',
    editNicsTitle: 'Modifiko rrjetet',
    nicDisconnected: 'e shkëputur'
  },
  ctTemplates: {
    title: 'Shabllonet CT',
    importAction: 'Importo nga katalogu',
    importTitle: 'Importo shabllon CT nga katalogu',
    importSubmit: 'Importo',
    importError: 'Importi u refuzua',
    importHint: 'Materializimi e kopjon rootfs-in në storage-in e zgjedhur — skedari i katalogut mbetet i paprekur. Për të shtuar skedarë të rinj, ngarkoji më parë brenda një katalogu.',
    sourceFile: 'Skedar shablloni CT',
    sourceFileHint: 'Skedarët ct-rootfs të katalogut të zgjedhur, vetëm ata gati',
    noFiles: 'Asnjë skedar ct-rootfs gati në këtë katalog — ngarko një nga faqja e katalogut',
    source: 'Skedari i origjinës',
    rootfsStorage: 'Storage-i i rootfs-it',
    rootfsStorageHint: "Ku jeton pema rootfs e ekstraktuar — një storage me sistem skedarësh dhe hapësirë të lirë të mjaftueshme për madhësinë e ekstraktuar plus rreth 1 GiB rezervë (përndryshe importi dështon).",
    resources: 'Burimet',
    cores: 'vCPU',
    memoryMiB: 'Memoria (MiB)',
    cpuLimit: 'Kufiri i CPU-së',
    cpuLimitHint: 'Ekuivalentë core-sh host (p.sh. 1.5); bosh = pa tavan',
    cpuUncapped: 'pa tavan',
    cpuWeight: 'Pesha e CPU-së',
    hostname: 'Hostname',
    hostnameHint: 'Bosh = emri i CT-së',
    nameservers: 'Nameserver DNS',
    dnsHint: 'Të ndarë me presje; bosh = trashëgon ata të host-it',
    searchDomains: 'Domenet e kërkimit DNS',
    dnsInherited: 'E trashëguar nga host-i',
    networks: 'Rrjetet',
    nicSlot: 'Slot NIC',
    phase: {
      materializing: 'Në materializim',
      ready: 'Gati',
      deleting: 'Duke u fshirë',
      error: 'Gabim'
    },
    exportAction: 'Eksporto në katalog',
    exportTitle: 'Eksporto në katalog',
    exportSubmit: 'Eksporto',
    exportError: 'Eksporti u refuzua',
    exportHint: 'E paketon rootfs-in e materializuar në një skedar të RI ct-rootfs në katalogun e zgjedhur — shablloni mbetet i paprekur.',
    exportName: 'Emri i skedarit',
    exportNameHint: 'Bosh = <template>-export-<n>',
    markCt: {
      action: 'Ktheje në CT',
      confirmTitle: "Të kthehet '{name}' në CT?",
      confirmBody: 'Shablloni e lë këtë listë dhe kthehet në listën CT, i nisshëm sërish. Derisa ta promovosh përsëri, prej tij nuk mund të krijohen CT.',
      confirm: 'Ktheje në CT',
      moved: "'{name}' është sërish një CT — e gjen në listën CT."
    }
  },

  // OCI wave 1 (Annex Q — il modello tag-come-branch): un tag OCI è un branch
  // (puntatore mobile), il digest è il commit; refresh = "git fetch",
  // pull = risolvi ADESSO, scarica QUEL digest.
  oci: {
    registriesTitle: 'Registry OCI',
    imagesTitle: 'Imazhet OCI',
    provider: 'Provider',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Gjenerik',
    providerImmutableHint: 'Provider-i është i pandryshueshëm pas krijimit — një provider tjetër është një registry i ri.',
    url: 'URL',
    urlHintPreset: 'I parambushur nga provider-i — mbishkruaje vetëm për mirror-ët.',
    urlHintRequired: 'I detyrueshëm për registry-t gjenerikë: URL-ja bazë https://.',
    urlHintEcr: 'I detyrueshëm: endpoint-et ECR janë për-llogari/për-rajon — nuk ekziston preset.',
    credential: 'Kredenciali',
    credentialNone: 'Qasje anonime',
    credentialHint: 'Një zë keystore përdorues-dhe-fjalëkalim; worker-ët e zgjidhin në momentin e përdorimit — kurrë auth file për nyjë.',
    nameHint: 'Emër i tipit host (docker.io, registry.intra); unik për scope, i pandryshueshëm',
    addRegistry: 'Shto registry',
    addRegistryTitle: 'Shto registry OCI',
    verify: 'Verifiko',
    verifyState: 'Verifikimi',
    verified: 'I verifikuar',
    verifyFailed: 'Dështoi',
    neverVerified: 'Asnjëherë i verifikuar',
    registryInUseError: "'{name}' ka ende repository të regjistruar — fshiji më parë.",
    repositories: 'Repository',
    repositoriesHint: 'Regjistrimi i vëzhgon branch-et (tag-e OCI) — nuk shkarkon asgjë. Rifreskimi zgjidh çdo branch të vëzhguar dhe mban reflog-un.',
    noRepositories: 'Asnjë repository i regjistruar në këtë registry.',
    registerRepository: 'Regjistro repository',
    repoPath: 'Shtegu',
    repoPathHint: "Shtegu i repository-t në registry, p.sh. 'example' ose 'library/nginx'",
    branches: 'Branch',
    branchesHint: 'Branch-e të vëzhguar (tag-e OCI), të ndarë me presje — p.sh. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Zgjidhet TANI: pull-i shkarkon digest-in te i cili branch-i tregon sot.',
    refresh: 'Rifresko',
    deleteRepository: 'Fshi repository-n',
    reflogCount: '{n} të mëparshme',
    noResolutions: 'Asnjëherë i rifreskuar — asnjë zgjidhje e vëzhguar.',
    refreshFailed: 'Rifreskimi i fundit dështoi ({when})',
    loadError: 'Repository-t nuk mund të ngarkoheshin.',
    reference: 'Referenca',
    digest: 'Digest',
    digestHint: 'sha256:… — imazhi i saktë, pa branch (detached)',
    size: 'Madhësia',
    nodes: 'Nyjet',
    detached: 'detached',
    detachedHint: 'E shkarkuar për digest, pa branch — kontrolli i drift-it nuk zbatohet.',
    pulledAt: 'Shkarkuar',
    pull: 'Pull',
    pullTitle: 'Pull imazhi',
    pullHint: 'Pre-warming, kurrë një parakusht: një pull për branch zgjidh TANI dhe shkarkon ATË digest; një pull për digest është detached.',
    pullError: 'Pull-i u refuzua',
    pullMode: 'Pull sipas',
    pullModeBranch: 'Branch (zgjidhe tani)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Default-i i ndershëm: si apt install, i riekzekutuar më vonë mund të japë një imazh tjetër.',
    pullModeDigestHint: 'Digest i saktë — riprodhueshmëri dhe rollback; heq dorë nga kontrolli i drift-it.',

    // Il pattern a due pulsanti (#88, ratifica 2026-07-30 sera): "da
    // registry" è il pull guidato esistente, "da catalogo" materializza un
    // archivio oci-image pronto (la via air-gapped).
    importFromRegistry: 'Importo nga registry',
    importFromCatalog: 'Importo nga katalogu',
    importCatalogTitle: 'Importo imazh OCI nga katalogu',
    importCatalogHint: 'Rruga air-gapped: një arkiv oci-image gati (tar/tar.gz — docker-archive ose oci-archive) materializohet në store-in e imazheve me referencën catalog/<catalogo>/<file>@<digest>; app-et e konsumojnë si çdo imazh tjetër. Arkivat ngarkohen në katalogë — ky seksion vetëm importon.',
    importCatalogFile: 'Arkivi',
    importCatalogFileHint: 'Skedarët oci-image gati të katalogut të zgjedhur.',
    importCatalogNoFiles: 'Asnjë arkiv oci-image gati në këtë katalog — ngarko një nga detajet e katalogut.',
    importCatalogError: 'Importi u refuzua',
    registry: 'Registry',
    repository: 'Repository',
    cacheMissing: 'Cache-i OCI i klasterit nuk është konfiguruar — pull-et refuzohen derisa të caktosh një pool storage-i.',
    setCache: 'Cakto cache-in',
    setCacheTitle: 'Konfiguro cache-in OCI',
    setCacheHint: 'Pool-i DEFAULT në nivel klasteri që strehon blob-et e imazheve të shkarkuara — një scope mund të bëjë override me pool-in e vet (faqja Scope). Ndërrimi nuk ndodh live dhe nuk rindez asgjë, dhe nuk i zhvendos blob-et: rishfaqen lazy në nisjen/përdorimin e ardhshëm.',
    cachePool: 'Pool storage-i',
    changeCache: 'Ndrysho cache-in',
    changeCacheTitle: 'Ndrysho pool-in e cache-it OCI',
    cacheCurrent: 'Cache-i OCI i klasterit (default): {name}',
    sectionOverview: 'Panorama',
    sectionRepositories: 'Repository',
    sectionExplore: 'Eksploro',
    exploreHint: 'Kërkim live në distancë mbi registry — Docker Hub i plotë (përshkrim, shkarkime, yje), provider-ët e tjerë best-effort. Zgjidh një rezultat për të lexuar përshkrimin e plotë dhe për të shfletuar tag-et në distancë; nga një tag mund t’ia shtosh referencën një repository-i TVirt.',
    exploreSearch: 'Kërko',
    exploreUnsupported: 'Ky provider nuk e mbështet kërkimin.',
    exploreNoResult: 'Asnjë repository përkatës.',
    exploreNoTags: 'Asnjë tag përkatës në këtë repository.',
    exploreOfficial: 'Zyrtar',
    explorePulls: 'Shkarkime',
    exploreStars: 'Yje',
    exploreUpdated: 'Përditësuar {when}',
    exploreLoadMore: 'Ngarko më shumë',
    exploreSelectHint: 'Zgjidh një rezultat: përshkrimi i plotë dhe tag-et në distancë ngarkohen këtu.',
    exploreNoDescription: 'Asnjë përshkrim i disponueshëm nga ky provider.',
    exploreTagsTitle: 'Tag-et në distancë',
    exploreTagFilter: 'Kërko tag',
    exploreAddToRepo: 'Shto në repository',
    exploreAdded: '{path}:{tag} tani gjurmohet — shih seksionin Repository.',
    addBranch: 'Shto branch',
    purgeRequiredTitle: "Të fshihet '{name}' dhe imazhet e tij?",
    purgeRequiredBody: 'Asnjë app nuk e konsumon këtë repository, por ekzistojnë ende imazhe të shkarkuara: fshirja e tij heq edhe record-et e tyre, dhe blob-et në cache i kalojnë garbage collector-it.',
    purgeConfirm: 'Fshi edhe imazhet',
    providerSelectHint: 'Zgjidh tipin e registry-t: karta tregon preset-et dhe përdorimin.',
    providerDesc: {
      dockerhub: 'Registry publik i Docker-it: URL e parambushur, kërkim i plotë me përshkrime dhe numërime.',
      ghcr: 'GitHub Container Registry: URL e parambushur; llogaritë përdorin një personal access token.',
      ecr: 'Amazon Elastic Container Registry: endpoint për-llogari/për-rajon — URL-ja duhet dhënë.',
      quay: 'Registry Red Hat Quay: URL e parambushur.',
      generic: 'Registry self-hosted (Harbor, registry:2, …): URL-ja https:// është e detyrueshme.'
    },

    // Dialog standard (round #156): i campi del dettaglio immagine/registry
    // che le colonne non mostravano.
    layerCount: 'Layer',
    verifiedAt: 'Verifikimi i fundit',
    verifyOk: 'Përfundimi',
    verifyMessage: 'Mesazhi i verifikimit',

    // Modeli #348/R39: imazhi ËSHTË digest-i — përmbajtja — dhe registry, depoja e dega janë EMRAT që e arrijnë.
    head: 'Head',
    heads: 'Koka sipas arkitekturës',
    listDigest: 'Digest-i i listës',
    neverResolved: 'Asnjëherë i zgjidhur',
    totalSize: 'Madhësia totale',
    reflogTitle: 'Historia e zgjidhjeve',
    usedBy: 'Përdorur nga',
    usageLockfile: 'lockfile',
    usageRunning: 'në ekzekutim',
    evictable: 'i dëbueshëm',
    evict: 'Dëbim nga cache-i',
    evictHeadTitle: 'Të dëbohet {digest}?',
    evictHeadBody: 'Është zgjidhja aktuale e të paktën një kolektori: dëbimi i tij është legjitim — është vetëm cache, branch-i në distancë e shërben ende — por nuk duhet të ndodhë gabimisht. Blob-i është NJË: dëbimi i zbraz të gjithë kolektorët që e ndajnë.',
    evictConfirm: 'Dëboje gjithsesi',

    arch: 'Arkitektura',
    names: 'Emrat',
    noNames: 'pa emër',
    views: 'Pamje',
    lastView: 'pamja e fundit',
    evictLastViewTitle: 'Të hiqet referenca e fundit te {digest}?',
    evictLastViewBody: 'Kjo është pamja e fundit mbi këtë përmbajtje: duke e hequr, imazhi pushon së ekzistuari në TVirt dhe bajtet ({size}) lirohen. Është docker image rm i modelit — jo një efekt anësor, por vetë veprimi.',
    branchesTabHint: 'Degët e vëzhguara të kësaj depoje: për secilën kokat e sotme — një për çdo arkitekturë — kronologjia e rifreskimeve dhe sa nga imazhet që ka emërtuar janë në cache. Rifreskimi është «git fetch» i depos: zgjidh të gjitha degët përnjëherë.',
    noBranches: 'Asnjë degë nuk vëzhgohet në këtë depo.',
    stopObserving: 'Ndalo vëzhgimin e degës',
    pullBranch: 'Shkarko në cache kokën e branch-it (refresh-i zgjidh, ky shkarkon)',
    pullDigest: 'Shkarko në cache këtë digest',
    imageCount: 'Imazhe',
    deleteBranchPurgeTitle: 'T’i lihen pa emër imazhet e {name}?',
    deleteBranchPurgeBody: 'Asnjë aplikacion nuk e emërton këtë degë, por disa imazhe arrihen vetëm përmes saj: duke e fshirë, ato mbeten në cache pa emër, të listuara mes imazheve të depos dhe të heqshme me dorë.',
    deleteBranchPurgeConfirm: 'Fshi dhe lëri imazhet pa emër',
    imagesTabHint: 'Imazhet e kësaj depoje — përmbajtjet, pra digest-et — të dukshme edhe pa zgjedhur një degë. Një imazh është unik për grumbull: emrat që e arrijnë mund të jenë disa.',
    noImages: 'Asnjë imazh i kësaj depoje nuk është materializuar në cache.',
    deleteRepositoryTitle: 'Të fshihet {name}?',
    deleteRepositoryBody: 'Depoja dhe degët e saj zhduken bashkë me kronologjinë. Imazhet mbeten në cache: humbin vetëm këtë emër. Një depo që e emërton një aplikacion nuk fshihet.',
    provenanceCatalog: 'katalog',
    refreshedAt: 'Rifreskuar',
    neverRefreshed: 'Kurrë e rifreskuar',
    sectionBranches: 'Degë',
    sectionImages: 'Imazhe',
    repositoriesGovernedElsewhere: 'Këtu depot vetëm shihen: regjistrimi, rifreskimi, vëzhgimi i degëve dhe heqja e imazheve bëhen te seksioni Imazhe OCI.',
    gotoImages: 'Shko te Imazhe OCI'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Pod-e',
    containers: 'Kontejnerë',
    instances: 'Instanca',
    instancesTooltip: '{running} në ekzekutim, {error} me gabim',
    placement: 'Vendosja',
    spread: 'shpërndarja',
    ha: 'HA',
    templateRevision: 'rishikim',
    deleting: 'Po fshihet',
    empty: 'Asnjë pod — krijoni një aplikacion (një kontejner) ose një pod nga CLI (create-pod).',
    openInstances: 'Hap instancat',
    rollingRestart: 'Rinisje me radhë',
    scale: 'Shkallëzo',
    scaleTitle: 'Shkallëzo {name}',
    scaleHint: 'Numri i instancave (0–64): lart zihet numri rendor më i ulët i lirë, poshtë tërhiqet më i larti dhe të dhënat e tij të qëndrueshme mbeten.',
    scaleError: 'Shkallëzimi dështoi',
    replicas: 'Replika',
    deleteRunningError: '{name} është në ekzekutim — ndaleni më parë.',
    deleteInstancesIntro: 'Të gjitha {count} instancat do të hiqen.',
    stateRunning: 'Në ekzekutim',
    stateStopped: 'Ndalur',
    editor: {
      createTitle: 'Krijo Pod',
      create: 'Krijo Pod',
      editTitle: 'Ndrysho Pod',
      nameHint: 'DNS-1123, më së shumti 58 karaktere — instancat quhen <emri>-<indeksi>; i pandryshueshëm pas krijimit.',
      restartPolicy: 'Politika e rinisjes',
      restartPolicyHint_always: 'Nyja rinis çdo kontejner që ka dalë, me backoff eksponencial (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Riniset vetëm një kontejner që del me kod jo zero; dalja 0 qëndron në qetësi.',
      restartPolicyHint_never: 'Një kontejner që ka dalë lihet siç është — instanca përfundon succeeded ose failed.',
      grace: 'Afati (s)',
      graceHint: 'Kufiri SIGTERM → SIGKILL i një ndalimi.',
      hostname: 'Emri i hostit',
      hostnameHint: 'Bosh = emri i instancës.',
      hostnameDefault: 'emri i instancës',
      sharePid: 'Ndaj hapësirën e emrave PID midis kontejnerëve',
      containersIntro: 'Kontejnerët init ekzekutohen deri në fund, me radhë, para se kontejnerët të nisin; kontejnerët ndajnë rrjetin e instancës (një IP, localhost mes tyre).',
      initContainers: 'Kontejnerët init',
      initAdd: 'Shto kontejner init',
      initHint: 'Secili duhet të dalë me 0; një dështim e vendos instancën në gabim dhe nyja e riprovon me backoff.',
      containerAdd: 'Shto kontejner',
      atLeastOne: 'Një Pod ka nevojë për të paktën një kontejner.',
      duplicateNames: 'Emrat e kontejnerëve duhet të jenë unikë brenda Pod-it (përfshirë kontejnerët init).',
      containerName: 'Emri i kontejnerit',
      containerInvalid: 'Ky kontejner është i paplotë: emri (DNS-1123), imazhi, montimet në vëllime të deklaruara, kufij dhe sondë numerikë.',
      command: 'Komanda',
      commandHint: 'Zëvendëson entrypoint-in e imazhit — një argument për rresht, kurrë një varg shell.',
      args: 'Argumentet',
      argsHint: 'Një për rresht (CMD i imazhit nëse bosh).',
      mounts: 'Montimet',
      mountAdd: 'Shto montim',
      mountNoVolumes: 'Deklaro fillimisht një vëllim në skedën Ruajtja.',
      readOnly: 'vetëm lexim',
      resources: 'Kufijtë',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (p.sh. 1.5)',
      memory: 'Memoria (MiB)',
      memoryHint: 'podman --memory',
      health: 'Sonda e gjallërisë',
      healthCmd: 'Komanda e sondës',
      healthCmdHint: 'Ekzekutohet brenda kontejnerit nga nyja në çdo tik mbikëqyrjeje — një argument për rresht; dalja 0 = i shëndetshëm.',
      healthTimeout: 'Koha maksimale (s)',
      healthRetries: 'Riprovime',
      healthRetriesHint: 'Dështime të njëpasnjëshme para se nyja të rinisë kontejnerin.',
      ips: 'Adresa statike',
      ipsHint: 'Një për instancë, sipas rendit — një shkallëzim përtej listës refuzohet.',
      instance: 'instancë',
      volumesHint: 'Vëllimet janë të Pod-it; rruga e montimit i takon çdo kontejneri (skeda Kontejnerët).',
      spread: 'Shpërndarja',
      spreadHint_preferred: 'Instancat në nyje të ndryshme kur është e mundur.',
      spreadHint_required: 'Instancat në nyje të ndryshme, ndryshe shkallëzimi refuzon.',
      spreadHint_none: 'Vetëm vendimmarrësi.',
      ha: 'Disponueshmëri e lartë (opt-in)',
      haHint: 'Çdo pjesë e qëndrueshme në storage të përbashkët; nëse nyja vdes, HA decider-i i rikrijon instancat në një anëtar tjetër (failover automatik, si VM-të HA).',
      yes: 'po',
      no: 'jo'
    },
    detail: {
      container: 'Kontejneri',
      actions: 'Veprimet',
      ready: 'Gati',
      notReady: 'Jo gati',
      restarts: 'Rinisjet',
      lastRestartAt: 'Rinisja e fundit:',
      backoffUntil: 'Riprovim në',
      stateAbsent: 'mungon',
      stateRunning: 'në ekzekutim',
      stateTerminated: 'përfunduar',
      stateWaiting: 'në pritje',
      init: 'init',
      noInstances: 'Asnjë instancë (replika 0).',
      ha: 'HA',
      haHint: 'Failover automatik: nëse nyja vdes, HA decider-i e rikrijon instancën në një anëtar tjetër (çdo pjesë e qëndrueshme në storage të përbashkët).',
      authority: 'Authority (nyje)',
      homeless: 'pa authority',
      homelessHint: 'Rikthimi nga checkpoint e lë jashtë authority-n (#380): asnjë nyje nuk e shërben derisa të shkallëzoni Pod-in (edhe në të njëjtin numër replikash).',
      restartContainer: 'Rinis vetëm këtë kontejner (pod-i mbetet aktiv)',
      divergingHint: 'Gjendja e dëshiruar e kësaj instance ndryshon nga parazgjedhja e Pod-it (PD-P19).',
      revisionLag: 'rishikimi {applied} i aplikuar nga {current}',
      updatedInstances: '{updated}/{desired} instanca në këtë rishikim'
    }
  }
}
